const acceptedImageMimeTypes = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/svg',
  'image/svg+xml'
];
const acceptedImageVideoTypes = [
  'video/mp4',
  'video/webm',
  'video/ogg',
  'video/AV1',
  'video/H264',
  'video/quicktime'
];
const acceptedImageDocumentTypes = [
  'application/pdf',
  'text/csv',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats',
  'officedocument.wordprocessingml.document'
];

export function isImageFile(rawFile) {

  return acceptedImageMimeTypes.indexOf(rawFile.type) !== -1;

}

export function isVideoFile(rawFile) {

  return acceptedImageVideoTypes.indexOf(rawFile.type) !== -1;

}

export function isDocumentFile(rawFile) {

  return acceptedImageDocumentTypes.indexOf(rawFile.type) !== -1;

}